import { render, staticRenderFns } from "./userManualseahourse.vue?vue&type=template&id=0c27236c&"
import script from "./userManualseahourse.vue?vue&type=script&lang=js&"
export * from "./userManualseahourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports